import { Tooltip } from "antd";
import React, { useMemo } from "react";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { typesConfigs } from "../../../../../constants/types";

export const Header = ({ config, isActive = false }) => {
  const headerConfig = useMemo(() =>
    typesConfigs.find((c) => c.type === config.type), [config]);

  return headerConfig ? (
    <div className={formatClassname(["header-cont", isActive && 'active'])}>
      <div className="header">
        <Tooltip title={config.label}>
          <div style={{
            width: '100%',
            background: '#fff',
            textAlign: 'start',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flexStart',
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}>
            <label className="label">
              {config.label}
            </label>
          </div>
        </Tooltip>
        <Tooltip title={config.title}>
          <div style={{
            width: '100%',
            background: '#fff',
            textAlign: 'start',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flexStart',
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}>
            <label className="type" style={{ color: headerConfig.color, wordBreak: 'break-all' }}>
              {config.title}
            </label>
          </div>
        </Tooltip>
      </div>
    </div>
  ) : null;
};
